import { render, staticRenderFns } from "./GeographicalDistributionChangeActivationType.vue?vue&type=template&id=8c381fb0&"
import script from "./GeographicalDistributionChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports